<div class="container-fluid text-center pt-5">
    <span class="section-title">What’s new in our blog</span>
    <div class="row justify-content-center pt-5 pb-3" *ngIf="!loading && blogs.length">
        <div class="col-11 col-sm-10">
            <div class="row">
                <div class="col-lg-6 blog-img-bg px-4 py-5 mb-auto">
                    <img class="blog-image" *ngIf="blogs[selectedBlogIndex].image" 
                    [src]="blogs[selectedBlogIndex].image" alt="blog image">
                    <img class="blog-image" *ngIf="!blogs[selectedBlogIndex].image" 
                    src="../../../../../assets/Images/blog-not-found.png" alt="blog image">
                </div>
                <div class="col-lg-6 text-left pl-lg-4 pt-2 mt-4 mt-lg-0">
                    <div class="d-flex flex-column justify-content-between h-100">
                        <div>
                            <p class="section-sub-title">{{blogs[selectedBlogIndex].title}}</p>
                            <div class="d-flex flex-row my-4 text-muted">
                                <i class="far fa-calendar"> <span
                                        class="ml-2 section-sub-text">{{blogs[selectedBlogIndex].createdAt | date:'EEE dd MMM'}}</span></i>
                                <i class="ml-5 fas fa-user"> <span
                                        class=" ml-2 section-sub-text">{{blogs[selectedBlogIndex].author.name}}</span></i>
                            </div>
                            <p class="blog-content-text">{{blogs[selectedBlogIndex].body}}
                                <span class="read-more-text ml-2" [routerLink]="['/blog-detail',blogs[selectedBlogIndex].postId]">READ MORE</span>
                            </p>
                        </div>
                        <div class="d-flex flex-row">
                            <div class="navigation-arrow mr-3" [ngClass]="{'disable-btn': selectedBlogIndex==0}"
                                (click)="navigateBlog(direction.DECREMENT)">
                                <i class="fas fa-long-arrow-alt-left arrow-icon"></i>
                            </div>
                            <div class="navigation-arrow"
                                [ngClass]="{'disable-btn': selectedBlogIndex == blogs.length - 1}"
                                (click)="navigateBlog(direction.INCREMENT)">
                                <i class="fas fa-long-arrow-alt-right arrow-icon"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row my-5" *ngIf="loading">
        <div class="spinner-border loader" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</div>